import React from 'react'
import {
    Container,
    ContentContainer,
    Heading,
    ItemContainer,
    ItemContent,
    ItemContentName,
    ItemContentValue,
    CardIcon
} from './DashboardSummary.styled'

export interface Item {
  name: string
  value: string
}

interface Props {
  heading?: string
  items: Item[]
}

const DashboardSummary: React.FC<Props> = ({
    heading,
    items
}: Props): JSX.Element => {

  return (
    <Container>
      <ContentContainer>
        {heading != null && <Heading>{heading}</Heading>}
        <ItemContainer>
          {items.map((item, index) => {
            return (
              <ItemContent key={item.name}>
                <CardIcon index={index} />
                <ItemContentName>{item.name}</ItemContentName>
                <ItemContentValue>{item.value}</ItemContentValue>
              </ItemContent>
            );
          })}
        </ItemContainer>
      </ContentContainer>
    </Container>
  );
};

export default DashboardSummary;
